export default "__VITE_ASSET__CMc2PIwy__"